import { HotelCard } from "@website/accommodation-ui/hotel-card-new";
import { HotelLastSecondCityPagePropertiesTypes } from "@website/accommodation-ui/hotel-last-second/hotel-last-second-city-page/hotel-last-second-city-page.type";
import { CarouselV2 } from "@website/ui/carousel";
import { Skeleton } from "@website/ui/skeleton";
import { today, tomorrow } from "@website/utils/date-format";
import { deepCompare } from "@website/utils/deep-compare";
import set from "lodash-es/set";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { FC, memo } from "react";
import { HotelLastSecondDiscountBox } from "../hotel-last-second-new-design";

const Component: FC<HotelLastSecondCityPagePropertiesTypes> = ({
  lastSecondHotels,
  loading,
  cityTitle
}) => {
  const router = useRouter();
  if (
    router.query["promotion"] ||
    !lastSecondHotels?.length ||
    ![today(), tomorrow()].includes(toString(router.query["date_from"]))
  ) {
    return;
  }

  const totalSlides = (lastSecondHotels?.length || 0) + 1;
  const isFewSlides = totalSlides < 4;
  return (
    <div className="bg-transparent-primary border-transparent-primary mx-[-24px] flex flex-col gap-4 border-y px-6 py-4 xl:mx-0 xl:rounded-xl xl:border">
      {loading ? (
        <div className="flex flex-col gap-4">
          <Skeleton className="!w-full" height={118} shape="rectangle" />
        </div>
      ) : (
        <>
          <div className="h-auto">
            <CarouselV2
              itemClass="max-w-[280px]"
              sectionClassName={` ${
                isFewSlides ? "flex gap-4 overflow-x-auto" : ""
              }`}
              keyCarousel={`last_sec_carousel_${cityTitle}`}
              mode="free-snap"
              options={{
                slides: {
                  perView: isFewSlides ? totalSlides : "auto",
                  spacing: 8
                },
                disabled: isFewSlides
              }}
              list={[
                <HotelLastSecondDiscountBox size="small" loading={loading} />,
                ...(lastSecondHotels?.map((hotel, index) => (
                  <HotelCard
                    index={index}
                    hotelInfo={set(
                      hotel,
                      "hotelDetail.hotelPageUrl.query.utm_source",
                      "last_second_hotels"
                    )}
                    key={hotel.id}
                    loading={loading}
                    isSuggestedCard
                    size="xSmall"
                  />
                )) || [])
              ]}
            />
          </div>
        </>
      )}
    </div>
  );
};
export const HotelLastSecondCityPage = memo(Component, deepCompare);
